<template>
<div class="relative chart-wrap">
    <highcharts class="h-full w-full" :options="options" :ref="chartId" id="chartId"></highcharts>
</div>
</template>

<script>
import {reduceBigNumbers} from '../main.js'
import {numberFormat} from '../main.js'
import { reduce } from 'highcharts'
let data = {}
const moment = require('moment')
    
export default {
    props: ['data', 'chartId'],
    data: function(){
        return {
            options: {
                chart: {
                    type: 'areaspline',
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    backgroundColor:'rgba(255,255,255,0)',
                    margin: [20,20,40,50]
                    // spacingBottom: 5,
                    // marginTop: 20,
                    // marginBottom: 20
                },
                title: {
                    text: ''
                },
                subtitle: {
                    text: ''
                },
                credits:{
                    enabled: false
                },
                xAxis:[
                
                    {
                    lineColor: 'rgba(255,255,255,0)',
                    title: {
                        text: null
                    },
                    labels: {
                        style:{
                            color:'#768194'
                        },
                        enabled: false
                    },
                    tickWidth: 0,
                    type: 'datetime',
                    // dateTimeLabelFormats: {
                    //     month: '%b'
                    // }
                    },

                    {
                    lineColor: 'rgba(255,255,255,0)',
                    title: {
                        text: null
                    },
                    labels: {
                        style:{
                            color:'#768194'
                        },
                        enabled: true
                    },
                    tickWidth: 0,
                    type: 'datetime',
                    // dateTimeLabelFormats: {
                    //     month: '%b'
                    // }
                    }
                ]
                ,
                exporting:{
                    enabled:false
                },
                yAxis:[{
                    title: {
                        text: '',
                    },
                    // type: 'logarithmic',
                    gridLineColor: '#AFA9A925',
                    labels: {
                        enabled: true,
                        formatter: function(){
                            return reduceBigNumbers(this.value,0)
                        }
                    },
                    tickAmount: 4,
                }],
                tooltip: {
                    enabled:true,
                    // pointFormat: '{point.y:,.1f}</b><br/>' + '{series.name}: <b>{point.y:,.1f}</b><br/>',
                    formatter: function() {
                        return `${numberFormat(this.y, 2)} €` ;
                    }
                },
                plotOptions: {
                    areaspline:{
                        fillOpacity:0,
                        lineWidth:3,
                        marker:{
                            enabled:false
                        },
                        shadow: {
                            offsetX: 2,
                            offsetY: 4,
                            opacity: .2,
                            width: 4,
                        }
                    }
                },
                legend: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                series: [
                    {
                        marker: {
                            width: 15,
                            height: 15
                        }
                    }
                ]
            }
        }
    },
    methods: {
        updateData(){
            
            let chart = this.$refs[this.chartId].chart;

            for(var i = chart.series.length -1; i > -1; i--) {
                chart.series[i].remove();
            }

            let num = 0,

            colors = ['rgb(74, 241, 177)', 'rgba(74, 241, 177, 0.25)']

            for(var serie in this.data){

                chart.addSeries({
                    data: this.data[serie],
                    name: this.data[serie],
                    xAxis: num,
                    color: colors[num]
                })

                num = num +1

            }

        }
    },
    watch: {
        data: {
            handler(a, b){
                this.updateData();
            },
            deep: true
        },
    },
    mounted() {
        this.updateData();
    }
};
</script>
<style lang="css">

    .highcharts-container{
        height: 100% !important;
        width: 100% !important;
    }

    .chart-wrap {
        height: 100%!important;
        width: 100% !important;
        position: relative;
        
    }

    .chart-wrap>div{
        height: 100% !important;
        width: 100% !important;                
    }
</style>